export const MOBILE_MAX_WIDTH = 768;

export const permissionLevels = {
  none: 0,
  thirdParty: 3,
  admin: 10,
  treasurer: 20,
  consultant: 21,
  webDesigner: 22,
  fundraiser: 40
}

// US state codes (plus DC) as select options
export const STATE_OPTIONS = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS",
  "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC",
  "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY",
].map((code) => ({ text: code, value: code }));
